"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsRouteList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _Permissions = require("../../constants/Permissions");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsRouteList Component
 * 
 * @description Screen for viewing the list of routes. This component displays a table 
 * of routes with options to create, edit, and delete routes, depending on user permissions.
 * 
 * @component
 * @example
 * return (
 *   <DmsRouteList />
 * )
 * 
 * @returns {JSX.Element} The route list table.
 */
const DmsRouteList = () => {
  const table = (0, _react.useRef)(null);
  const route_header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("url").d("Url"),
    column_name: "route",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    column_name: "actions",
    permissions: [_Permissions.Permissions.CAN_EDIT_ROUTE_LIST],
    width: "80px",
    sortable: false,
    can_create: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Updateroute", {
          name
        }).d("Update {name}"),
        url: "/route_list/",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Deleteroute", {
          name
        }).d("Delete {name}"),
        text: _reactIntlUniversal.default.get("DmsRouteList.deleteButton.text", {
          name
        }).d("The route with path {name} will be deleted.\n                            Are you sure about it?"),
        url: "/route_list/",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_ROUTE_LIST
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    header: route_header,
    table: table,
    title: _reactIntlUniversal.default.get("Createroute").d("Create route"),
    url: "/route_list"
  }))));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    header: route_header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/route_list/table",
    export_table: false,
    toolbar: toolbar
  }));
};
exports.DmsRouteList = DmsRouteList;